type Status = 'active' | 'expired' | 'test' | 'prod' | 'revoked' | 'pending';

const COLORS: Record<Status, string> = {
  active: 'text-success',
  prod: 'text-success',
  test: 'text-accent',
  pending: 'text-warn',
  expired: 'text-danger',
  revoked: 'text-danger',
};

/** Colored `[STATUS]` badge for cert/device state. */
export function StatusBadge({ status }: { status: Status }) {
  return <span className={`status-badge ${COLORS[status]}`}>[{status.toUpperCase()}]</span>;
}
